import { HttpInterceptorFn } from '@angular/common/http';
import { environment } from '../../environments/environment';

export const baseUrlInterceptor: HttpInterceptorFn = (req, next) => {
  const ignoreUrlStartsWith: string[] = ['favicon.ico', './assets', 'http'];

  const shouldIgnore = ignoreUrlStartsWith.some(url => req.url.startsWith(url));

  if (shouldIgnore) {
    return next(req);
  }

  const modifiedReq = req.clone({
    url: `${environment.apiBaseUrl}${req.url}`,
  });

  return next(modifiedReq);
};
